import React from 'react';

import AppointmentDialog from './AppointmentDialog';
import AppointmentFormDialog from './AppointmentFormDialog';
import DeleteAppointmentDialog from './DeleteAppointmentDialog';

const Dialogs = () => (
  <>
    <AppointmentDialog />
    <AppointmentFormDialog />
    <DeleteAppointmentDialog />
  </>
);

export default Dialogs;
